
import Vue from "vue";
import Headline from "../components/shared/Headline.vue";
import Breadcrumb from "../components/shared/Breadcrumb.vue";
import BreadcrumbItem from "../components/shared/BreadcrumbItem.vue";
import UserAPI from "../api/UserAPI";

export default Vue.extend({
  name: "myPage",
  components: {
    Headline,
    Breadcrumb,
    BreadcrumbItem,
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const storedId = localStorage.getItem("userId");

      if (storedId) {
        this.$router.push(`/minasan/${storedId}`);
      } else {
        const newUser = await UserAPI.create();
        localStorage.setItem("userId", newUser.id);
        localStorage.setItem("userToken", newUser.token);
        this.$router.push(`/minasan/${newUser.id}`);
      }
    },
  },
});

